export const EMAILS = {
  CONTACT_CUREWIKI_HEALTH: 'contact@curewiki.health',
  PATIENTS_CUREWIKI_HEALTH: 'patients@curewiki.health',
} as const;
